<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Anti Sexual Harassment Grievance Cell</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
<section class="section-lg std-scholarship">
    <div class="container">
        <div class="table-responsive" >
            <table class="table table-bordered text-center tbl_custom">
				<thead>
					<tr>
						<th>Sr. No.</th>
						<th>Name</th>
						<th>Designation</th>
						
					</tr>
				</thead>
				<tbody>
					
					<tr>
						<td>1</td>
						<td>Dr. Jasvinder Kaur</td>
						<td>Chairperson</td>
					</tr>
					<tr>
						<td>2</td>
						<td>Mr. Vishal Dhabalia</td>
						<td>Member (Teaching)</td>
					</tr>
					<tr>
						<td>3</td>
						<td>Ms. Kalyani Dubey</td>
						<td>Member (Teaching)</td>
					</tr>
					<tr>
						<td>4</td>
						<td>Ms Bindiya Turkar</td>
						<td>Member (Teaching)</td>
					</tr>
					<tr>
						<td>5</td>
						<td>Mr Sachin Bhonsale</td>
						<td>Member (Non-Teaching)</td>
					</tr>
					<tr>
						<td>6</td>
						<td>Ms. Anjali Sahane</td>
						<td>Member (Student)</td>
					</tr>
					<tr>
						<td>7</td>
						<td>Mr. Ishmeet Singh</td>
						<td>Member (Student)</td>
					</tr>
					
				</tbody>
			</table>
        </div>
    </div>
</section>
